(() => {
  'use strict';
  function availablePairs(pair) {
    return pair.saturday.filter(v => v.available && pair.sunday.some(s => s.available && s.title === v.title));
  }
  function priceBundle(pair, title, quantity) {
    const a = pair.saturday.find(v => v.available && v.title === title);
    const b = pair.sunday.find(v => v.available && v.title === title);
    if (!a || !b || !Number.isInteger(quantity) || quantity < 1 || quantity > 100) return null;
    const regular = (a.price + b.price) * quantity;
    const savings = Math.round(b.price * quantity * 0.1);
    return { regular, savings, total: regular - savings, items: [{id:a.id,quantity},{id:b.id,quantity}] };
  }
  function start(root) {
    if (root.dataset.initialized) return;
    const field = name => root.querySelector('[data-' + name + ']');
    let pairs;
    try { pairs = JSON.parse(field('config').textContent); } catch { field('status').textContent = 'The bundle builder could not load. Please choose your tickets by day.'; return; }
    if (!pairs.length) return;
    root.dataset.initialized = 'true';
    const chooser = field('pair'), tier = field('tier'), qty = field('qty'), button = field('add'), status = field('status'), summary = field('summary');
    let current = pairs[0], quote = null, busy = false;
    const money = n => new Intl.NumberFormat('en-US', {style:'currency', currency:root.dataset.currency || 'USD'}).format(n / 100);
    const option = (value, label) => new Option(label, value);
    if (chooser) pairs.forEach((p, i) => chooser.add(option(i, p.name)));
    function refresh() {
      quote = priceBundle(current, tier.value, Number(qty.value));
      summary.replaceChildren();
      if (quote) {
        const breakdown = document.createElement('p'), total = document.createElement('p');
        breakdown.textContent = 'Ticket subtotal ' + money(quote.regular) + ' · Sunday savings ' + money(quote.savings);
        total.className = 'ps-bundle-total';
        total.textContent = 'Estimated bundle total ' + money(quote.total);
        summary.append(breakdown, total);
        status.textContent = 'Review the discount in your cart.';
      } else {
        status.textContent = tier.options.length ? 'Enter a quantity from 1 to 100.' : 'No matching ticket sections are available for both days. Check the individual ticket pages for availability.';
      }
      button.disabled = busy || !quote;
    }
    function choose() {
      const previous = tier.value;
      current = pairs[Number(chooser?.value || 0)];
      field('dates').textContent = current.name + ': ' + current.dates.join(' + ');
      tier.replaceChildren();
      const variants = availablePairs(current);
      variants.forEach(v => tier.add(option(v.title, v.title)));
      tier.disabled = !variants.length;
      if (variants.some(v => v.title === previous)) tier.value = previous;
      refresh();
    }
    chooser?.addEventListener('change', choose);
    tier.addEventListener('change', refresh);
    qty.addEventListener('input', refresh);
    button.addEventListener('click', async () => {
      if (!quote || busy) return;
      busy = true;
      button.disabled = true;
      status.textContent = 'Adding Saturday and Sunday to your cart…';
      const base = window.Shopify?.routes?.root || '/';
      try {
        const res = await fetch(base + 'cart/add.js', {
          method:'POST', credentials:'same-origin',
          headers:{'Content-Type':'application/json', 'Accept':'application/json'},
          body:JSON.stringify({items:quote.items})
        });
        if (!res.ok) {
          const error = await res.json().catch(() => ({}));
          throw new Error(error.description || 'These tickets could not be added. Check availability or try a smaller quantity.');
        }
        window.location.assign(base + 'cart');
      } catch(e) {
        busy = false;
        button.disabled = !quote;
        status.textContent = e.message;
      }
    });
    choose();
  }
  function init() { document.querySelectorAll('.ps-bundle[data-currency]').forEach(start); }
  init();
  document.addEventListener('shopify:section:load', init);
})();
